export default {
    accidents: [],
    accidentsLoading: false,
    accidentTypes: [],
    machines: [],
    machinesBasicData: [],
    accidentLoading: false,
    accidentStatuses: [],
    accidentDepartments: [],
    accidentUserDepartments: [],
    productionDepartments: [],
    softwareTypes: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        accidentStatus : null,
        machineId: null,
        softwareType: null,
        accidentDepartment: null,
        createdAt__gte: null,
        createdAt__lte: null,
        lastAssignee: null,
        isSolved: true
    }
}
